import React, { useContext } from 'react';
import { ChromeContext } from 'services/chrome/chromeBridge';
import { getOpenTab } from 'services/chrome/utils';
import { observer } from 'mobx-react';
import { appEnvironment } from 'helpers';
import classNames from 'classnames';
import styles from './FileLink.module.scss';

interface FileLinkProps {
  url: string;
  baseUrl: string;
  name: string;
}

export const FileLink: React.FC<FileLinkProps> = ({ url, baseUrl, name }) => {
  if (appEnvironment === 'chrome') {
    return <FileLinkChrome url={url} baseUrl={baseUrl} name={name} />;
  }

  return <OpenNewLink name={name} url={url} />;
};

interface FileLinkChromeProps {
  url: string;
  baseUrl: string;
  name: string;
}

export const FileLinkChrome: React.FC<FileLinkChromeProps> = observer(({ url, baseUrl, name }) => {
  const chromeBridge = useContext(ChromeContext);
  const openTab = getOpenTab(chromeBridge, baseUrl);

  if (openTab) {
    return (
      <div
        onClick={() => {
          chrome.tabs.update(openTab.id, {
            selected: true,
          });
          chrome.windows.update(openTab.windowId, {
            focused: true,
          });
        }}
        className={classNames(styles.title, styles.clickable)}
      >
        {name}
      </div>
    );
  }

  return <OpenNewLink name={name} url={url} />;
});

interface OpenNewLinkProps {
  url: string;
  name: string;
}

export const OpenNewLink: React.FC<OpenNewLinkProps> = ({ url, name }) => {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={classNames(styles.title, styles.clickable)}
    >
      {name}
    </a>
  );
};
